<template><!--管理员设置-->
  <div style="padding: 20px">

    <el-form  style="text-align: center; " class="demo-form-inline" ref="listForm" :inline="true" :model="formInline">

      <el-form-item label="时间">
        <el-date-picker
            v-model="formInline.time"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至 "
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getList()">查询</el-button>
      </el-form-item>
    </el-form>


    <el-table :data="tableData" border style="width: 99%">
      <el-table-column align="center" prop="time" label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.time }} 点</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="count" label="次数"></el-table-column>
      <el-table-column align="center" prop="man" label="男性"></el-table-column>
      <el-table-column align="center" prop="women" label="女性"></el-table-column>
      <el-table-column align="center" prop="other" label="注册但未完善信息"></el-table-column>
    </el-table>


    <!--分页-->
    <!--<el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :current-page="currentPage"
        :page-size="currentSize"
        :total="currentTotal"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        background
        style="text-align: center;margin-top:40px;">
    </el-pagination>-->

  </div>
</template>

<script>

import {ChartsYybApi} from "@/api/api";

export default {
  data() {
    return {
      tableData: [],  //  后台传输过来的数据

      //  过滤查询条件
      formInline: {
        time: [],
        key: 'UefdcGP2',
      },

      //  分页
      currentPage: 1,     //  当前页
      currentSize: 10,    // 当前每页显示条数
      currentTotal: 0,    // 当前数据的总条数
    }
  },
  methods: {
    //  每页条数 改变时会触发
    /*handleSizeChange(val) {
      this.currentSize = val;
      this.currentPage = 1;  //  当前页
      this.getList();
    },*/
    //  页数 改变时会触发
    /*handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },*/
    //  查询
    getList() {
      // if (sign) this.currentPage = 1; //  重置当前页
      if (!this.formInline.time) this.formInline.time = [];
      if (!this.formInline.time[0]) this.formInline.time[0] = new Date().toLocaleDateString().split('/').join('-');
      // if (!this.formInline.time[1]) this.formInline.time[1] = new Date().toLocaleDateString().split('/').join('-');

      ChartsYybApi(
          'key=' + this.formInline.key +
          '&start_time=' + this.formInline.time[0] +
          '&end_time=' + this.formInline.time[1]
      ).then(data => {
        this.tableData = data;
        // this.currentTotal = data.count;
      })
    },
  },
  created() { //  页面加载事件

    this.getList();    //  页面加载直接查询
  }
}
</script>
